<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>

<div
  class=""
  style="
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;
    padding: 1.5rem;
    background-color: #ffffff;
  "
>
  <div class="contents" style="flex-grow: 1; overflow: auto">
    <div
      class="ui vertical basic segment"
      *ngIf="success || error"
      appMargin
      marginB="10px"
    >
      <esl-message-toast [(message)]="error"></esl-message-toast>
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
    </div>

    <div class="content">
      <div
        class="scroll-wrapper ui basic segment"
        appPadding="0"
        [ngClass]="{ loading: pending || pendingArr.length }"
      >
        <ng-container *ngIf="isPending">
          <div
            fxLayout="row"
            fxLayoutAlign="start center"
            class="clickable"
            style="margin-left: -8px"
            (click)="goBackToList()"
          >
            <span><i class="angle left icon"></i></span>
            <span class="back-text">Go back</span>
          </div>
          <div class="ui basic segment" appPadding paddingX="0">
            <div
              fxLayoutAlign="end"
              style="margin-top: 15px"
              *ngIf="selectedRequest.changeRequestType !== 'CEO-INFORMATION'"
            >
              <div
                class="ui tiny circular label"
                [ngClass]="{
                  'label-green': selectedRequest.status == 'VERIFIED',
                  'label-grey': selectedRequest.status == 'NOT_AVAILABLE',
                  'label-red':
                    selectedRequest.status == 'REJECTED' ||
                    selectedRequest.status == 'UNVERIFIED',
                  'label-orange': selectedRequest.status == 'PENDING'
                }"
                style="
                  position: relative;
                  bottom: 1.2rem;
                  height: 20px !important;
                  padding: 0 10px !important;
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  font-weight: 400;
                  white-space: nowrap;
                  margin-bottom: 10px;
                "
              >
                {{
                  selectedRequest.status == "PENDING"
                    ? "PENDING VERIFICATION"
                    : selectedRequest.status == "REJECTED"
                    ? "FAILED VERIFICATION"
                    : selectedRequest.status == "UNVERIFIED"
                    ? "UNVERIFIED VERIFICATION"
                    : selectedRequest.status == "VERIFIED"
                    ? "VERIFIED"
                    : selectedRequest.status
                }}
              </div>
            </div>

            <div
              *ngIf="selectedRequest.status == 'UNVERIFIED'"
              class="ui label warning-label label-two"
              style="
                flex-direction: column;
                flex-direction: column;
                align-items: flex-start;
                gap: 8px;
                padding: 12px 10px;
              "
            >
              <div>
                <h2
                  style="
                    font-size: 11px;
                    font-weight: 700;
                    line-height: 14.49px;
                    text-align: left;
                    color: #828282;
                  "
                >
                  REJECTION REASON:
                </h2>
              </div>
              <div style="display: flex; align-items: center; gap: 8px">
                <span
                  ><img
                    src="../../../../../assets/icons/warning-icon.svg"
                    alt=""
                /></span>
                <div class="text" style="text-transform: capitalize">
                  {{ selectedRequest.remark }}
                </div>
              </div>
            </div>

            <div class="ui vertical segment card-two">
              <div appMargin marginB="20px">
                <div
                  fxLayout="row"
                  style="
                    font-size: 11px;
                    font-weight: 700;
                    line-height: 14.49px;
                    text-align: left;
                    color: #828282;
                  "
                >
                  CREATED BY
                </div>
                <br />
                <div fxLayout="row">
                  <small appMargin marginR="10px" class="card-label-2">
                    <i class="user outline icon"></i>
                    {{ selectedRequest.createdBy | createdBy }}
                  </small>
                  <small class="card-label-2">
                    <i class="clock outline icon"></i>
                    {{ selectedRequest.dateCreated | date: "medium" }}
                  </small>
                </div>
              </div>

              <div *ngIf="selectedRequest.status == 'REJECTED'">
                <div
                  fxLayout="row"
                  style="
                    font-size: 11px;
                    font-weight: 700;
                    line-height: 14.49px;
                    text-align: left;
                    color: #828282;
                  "
                >
                  REJECTED BY
                </div>
                <br />
                <div fxLayout="row">
                  <small appMargin marginR="10px" class="card-label-2">
                    <i class="user outline icon"></i>
                    {{ selectedRequest.createdBy | createdBy }}
                  </small>
                  <small class="card-label-2">
                    <i class="clock outline icon"></i>
                    {{ selectedRequest.dateCreated | date: "medium" }}
                  </small>
                </div>
              </div>
              <!-- <div *ngIf="selectedRequest.status == 'VERIFIED'">
            <div fxLayout="row" style="font-weight: 600">APPROVED BY</div>
            <br />
            <div fxLayout="row">
              <small appMargin marginR="10px">
                <i class="user icon"></i>
                {{ selectedRequest.approvedBy | createdBy }}
              </small>
              <small>
                <i class="clock icon"></i>
                {{ selectedRequest.dateApproved | date: "medium" }}
              </small>
            </div>
          </div> -->
            </div>
          </div>
          <ng-container
            *ngIf="
              fromValue &&
              selectedRequest.changeRequestType == 'OFFICIAL_DOCUMENT'
            "
          >
            <h2
              style="
                font-weight: 600;
                font-size: 16px;
                line-height: 19px;
                color: #3f4395;
              "
            >
              INITIAL RECORD
            </h2>
            <div class="ui divider"></div>
            <div appMargin marginB="15px">
              <div class="ui heading">NO RECORD</div>
            </div>
          </ng-container>
          <ng-container
            *ngIf="
              detail && selectedRequest.changeRequestType == 'OFFICIAL_DOCUMENT'
            "
          >
            <h2
              style="
                font-weight: 600;
                font-size: 16px;
                line-height: 19px;
                color: #3f4395;
              "
            >
              {{ selectedRequest.status }} RECORD
            </h2>
            <div class="ui divider"></div>

            <div appMargin marginB="15px">
              <div class="ui heading">DOCUMENT NAME</div>
              <div class="ui heading-bottom">{{ detail.documentName }}</div>
            </div>

            <div appMargin marginB="15px">
              <div class="ui heading">DOCUMENT TYPE</div>
              <div class="ui heading-bottom">
                {{ filterDocumentType(detail.documentTypeId) }}
              </div>
            </div>
          </ng-container>
          <ng-container
            *ngIf="
              fromValue && selectedRequest.changeRequestType == 'COMPANY_NAME'
            "
          >
            <h2
              style="
                font-weight: 600;
                font-size: 16px;
                line-height: 19px;
                color: #3f4395;
              "
            >
              INITIAL RECORD
            </h2>
            <h2>Company Name</h2>
            <div class="ui divider"></div>

            <div appMargin marginB="15px">
              <div class="ui heading">COMPANY NAME</div>
              <div class="ui heading-bottom">{{ fromValue.companyName }}</div>
            </div>
          </ng-container>
          <ng-container
            *ngIf="
              detail && selectedRequest.changeRequestType == 'COMPANY_NAME'
            "
          >
            <h2
              style="
                font-weight: 600;
                font-size: 16px;
                line-height: 19px;
                color: #3f4395;
              "
            >
              {{ selectedRequest.status }} RECORD
            </h2>
            <h2>Company Name</h2>
            <div class="ui divider"></div>

            <div appMargin marginB="15px">
              <div class="ui heading">COMPANY NAME</div>
              <div class="ui heading-bottom">{{ detail.companyName }}</div>
            </div>
          </ng-container>

          <ng-container
            *ngIf="
              fromValue &&
              (selectedRequest.changeRequestType == 'TIN' ||
                selectedRequest.changeRequestType == 'OTHER_TIN')
            "
          >
            <table
              class="custom-table"
              *ngIf="
                detail.firsRecord &&
                selectedRequest.changeRequestType !== 'OTHER_TIN'
              "
            >
              <thead>
                <tr>
                  <th></th>
                  <th>Company Record</th>
                  <th>Company Record from FIRS</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Company Name</td>
                  <td>{{ companyOrganization.companyName }}</td>
                  <td>{{ detail.firsRecord.TaxPayerName }}</td>
                </tr>
                <tr>
                  <td>Tin Number</td>
                  <td>{{ detail.tinNumber }}</td>
                  <td>{{ detail.tinNumber }}</td>
                </tr>
                <tr>
                  <td>RC Number</td>
                  <td>{{ companyOrganization.rcNumber }}</td>
                  <td>{{ detail.firsRecord.RCNumber.replace("RC", "") }}</td>
                </tr>
              </tbody>
            </table>
            <h2
              style="
                font-weight: 600;
                font-size: 16px;
                line-height: 19px;
                color: #3f4395;
              "
            >
              INITIAL RECORD
            </h2>
            <h2>
              Company
              {{
                selectedRequest.changeRequestType == "OTHER_TIN"
                  ? "OTHER TIN"
                  : "TIN"
              }}
            </h2>
            <div class="ui divider"></div>

            <div appMargin marginB="15px">
              <div class="ui heading">
                {{
                  selectedRequest.changeRequestType == "OTHER_TIN"
                    ? "OTHER TIN"
                    : "TIN"
                }}
              </div>
              <div class="ui heading-bottom">{{ fromValue.tinNumber }}</div>
            </div>
          </ng-container>
          <ng-container
            *ngIf="
              detail &&
              (selectedRequest.changeRequestType == 'TIN' ||
                selectedRequest.changeRequestType == 'OTHER_TIN')
            "
          >
            <h2
              style="
                font-weight: 600;
                font-size: 16px;
                line-height: 19px;
                color: #3f4395;
              "
            >
              {{ selectedRequest.status }} RECORD
            </h2>
            <h2>
              Company
              {{
                selectedRequest.changeRequestType == "OTHER_TIN"
                  ? "OTHER TIN"
                  : "TIN"
              }}
            </h2>
            <div class="ui divider"></div>

            <div appMargin marginB="15px">
              <div class="ui heading">
                {{
                  selectedRequest.changeRequestType == "OTHER_TIN"
                    ? "OTHER TIN"
                    : "TIN"
                }}
              </div>
              <div class="ui heading-bottom">{{ detail.tinNumber }}</div>
            </div>
          </ng-container>
          <ng-container
            *ngIf="fromValue && selectedRequest.changeRequestType == 'ADDRESS'"
          >
            <h2
              style="
                font-weight: 600;
                font-size: 16px;
                line-height: 19px;
                color: #3f4395;
              "
            >
              INITIAL RECORD
            </h2>
            <h2>Company ADDRESS</h2>
            <div class="ui divider"></div>

            <div appMargin marginB="15px">
              <div class="ui heading">STREET</div>
              <div class="ui heading-bottom">
                {{ fromValue.headOfficeAddressStreet }}
              </div>
            </div>

            <div appMargin marginB="15px">
              <div class="ui heading">CITY</div>
              <div class="ui heading-bottom">
                {{ fromValue.headOfficeAddressCity }}
              </div>
            </div>

            <div appMargin marginB="15px">
              <div class="ui heading">STATE</div>
              <div class="ui heading-bottom">
                {{
                  filterStates(
                    fromValue.headOfficeAddressState
                      ? fromValue.headOfficeAddressState
                      : fromValue.headOfficeAddressStateId
                  )
                }}
              </div>
            </div>

            <div appMargin marginB="15px">
              <div class="ui heading">ZIP</div>
              <div class="ui heading-bottom">
                {{ fromValue.headOfficeAddressZip }}
              </div>
            </div>

            <div appMargin marginB="15px">
              <div class="ui heading">COUNTRY</div>
              <div class="ui heading-bottom">
                {{ filterCountry(fromValue.countryOfRegistration) }}
              </div>
            </div>
          </ng-container>
          <ng-container
            *ngIf="detail && selectedRequest.changeRequestType == 'ADDRESS'"
          >
            <h2
              style="
                font-weight: 600;
                font-size: 16px;
                line-height: 19px;
                color: #3f4395;
              "
            >
              {{ selectedRequest.status }} RECORD
            </h2>
            <h2>Company ADDRESS</h2>
            <div class="ui divider"></div>

            <div appMargin marginB="15px">
              <div class="ui heading">STREET</div>
              <div class="ui heading-bottom">
                {{ detail.headOfficeAddressStreet }}
              </div>
            </div>

            <div appMargin marginB="15px">
              <div class="ui heading">CITY</div>
              <div class="ui heading-bottom">
                {{ detail.headOfficeAddressCity }}
              </div>
            </div>

            <div appMargin marginB="15px">
              <div class="ui heading">STATE</div>
              <div class="ui heading-bottom">
                {{
                  filterStates(
                    detail.headOfficeAddressState
                      ? detail.headOfficeAddressState
                      : detail.headOfficeAddressStateId
                  )
                }}
              </div>
            </div>

            <div appMargin marginB="15px">
              <div class="ui heading">ZIP</div>
              <div class="ui heading-bottom">
                {{ detail.headOfficeAddressZip }}
              </div>
            </div>

            <div appMargin marginB="15px">
              <div class="ui heading">COUNTRY</div>
              <div class="ui heading-bottom">
                {{ filterCountry(detail.countryOfRegistration) }}
              </div>
            </div>
          </ng-container>
          <ng-container
            *ngIf="
              fromValue && selectedRequest.changeRequestType == 'RC_NUMBER'
            "
          >
            <h2
              style="
                font-weight: 600;
                font-size: 16px;
                line-height: 19px;
                color: #3f4395;
              "
            >
              INITIAL RECORD
            </h2>
            <h2>COMPANY REGISTRATION DETAILS</h2>
            <div class="ui divider"></div>

            <div appMargin marginB="15px">
              <div class="ui heading">RC NUMBER</div>
              <div class="ui heading-bottom">{{ fromValue.rcNumber }}</div>
            </div>

            <div appMargin marginB="15px">
              <div class="ui heading">COMPANY TYPE</div>
              <div class="ui heading-bottom">
                {{ fromValue.companyType | removeUnderscore }}
              </div>
            </div>

            <div appMargin marginB="15px">
              <div class="ui heading">OWNERSHIP TYPE</div>
              <div class="ui heading-bottom">
                {{ fromValue.ownershipType | removeUnderscore }}
              </div>
            </div>

            <div appMargin marginB="15px">
              <div class="ui heading">REGISTRATION DATE</div>
              <div class="ui heading-bottom">
                {{ fromValue.dateOfRegistration | date: "medium" }}
              </div>
            </div>
          </ng-container>
          <ng-container
            *ngIf="detail && selectedRequest.changeRequestType == 'RC_NUMBER'"
          >
            <h2
              style="
                font-weight: 600;
                font-size: 16px;
                line-height: 19px;
                color: #3f4395;
              "
            >
              {{ selectedRequest.status }} RECORD
            </h2>
            <h2>COMPANY REGISTRATION DETAILS</h2>
            <div class="ui divider"></div>

            <div appMargin marginB="15px">
              <div class="ui heading">RC NUMBER</div>
              <div class="ui heading-bottom">{{ detail.rcNumber }}</div>
            </div>

            <div appMargin marginB="15px">
              <div class="ui heading">COMPANY TYPE</div>
              <div class="ui heading-bottom">
                {{ detail.companyType | removeUnderscore }}
              </div>
            </div>

            <div appMargin marginB="15px">
              <div class="ui heading">OWNERSHIP TYPE</div>
              <div class="ui heading-bottom">
                {{ detail.ownershipType | removeUnderscore }}
              </div>
            </div>

            <div appMargin marginB="15px">
              <div class="ui heading">REGISTRATION DATE</div>
              <div class="ui heading-bottom">
                {{ detail.dateOfRegistration | date: "medium" }}
              </div>
            </div>
          </ng-container>

          <ng-container
            *ngIf="
              fromValue &&
              selectedRequest.changeRequestType == 'CONTACT_INFORMATION'
            "
          >
            <h2
              style="
                font-weight: 600;
                font-size: 16px;
                line-height: 19px;
                color: #3f4395;
              "
            >
              INITIAL RECORD
            </h2>
            <h2>Company CONTACT</h2>
            <div class="ui divider"></div>

            <div appMargin marginB="15px">
              <div class="ui heading">EMAIL</div>
              <div class="ui heading-bottom">
                {{ fromValue.companyContactEmail }}
              </div>
            </div>

            <div appMargin marginB="15px">
              <div class="ui heading">ALTERNATIVE EMAIL</div>
              <div class="ui heading-bottom">
                {{ fromValue.companyContactAlternativeEmail }}
              </div>
            </div>

            <div appMargin marginB="15px">
              <div class="ui heading">ALTERNATIVE PHONE</div>
              <div class="ui heading-bottom">
                {{ fromValue.companyContactPhone1 }}
              </div>
            </div>

            <div appMargin marginB="15px">
              <div class="ui heading">WEBSITE</div>
              <div class="ui heading-bottom">{{ fromValue.website }}</div>
            </div>
          </ng-container>
          <ng-container
            *ngIf="
              fromValue &&
              selectedRequest.changeRequestType == 'CEO-INFORMATION'
            "
          >
            <h2
              style="
                font-weight: 600;
                font-size: 16px;
                line-height: 19px;
                color: #3f4395;
              "
            >
              INITIAL RECORD
            </h2>
            <h2>COMPANY CEO</h2>
            <div class="ui divider"></div>

            <div appMargin marginB="15px">
              <div class="ui heading">Name of CEO</div>
              <div class="ui heading-bottom">{{ fromValue.ceoName }}</div>
            </div>

            <div appMargin marginB="15px">
              <div class="ui heading">Email Address</div>
              <div class="ui heading-bottom">
                {{ fromValue.ceoContactEmail }}
              </div>
            </div>

            <div appMargin marginB="15px">
              <div class="ui heading">Phone Number</div>
              <div class="ui heading-bottom">
                {{ fromValue.ceoContactPhone }}
              </div>
            </div>
          </ng-container>
          <ng-container
            *ngIf="
              detail &&
              selectedRequest.changeRequestType == 'CONTACT_INFORMATION'
            "
          >
            <h2
              style="
                font-weight: 600;
                font-size: 16px;
                line-height: 19px;
                color: #3f4395;
              "
            >
              {{ selectedRequest.status }} RECORD
            </h2>

            <h2>Company CONTACT</h2>
            <div class="ui divider"></div>

            <div appMargin marginB="15px">
              <div class="ui heading">EMAIL</div>
              <div class="ui heading-bottom">
                {{ detail.companyContactEmail }}
              </div>
            </div>

            <div appMargin marginB="15px">
              <div class="ui heading">ALTERNATIVE EMAIL</div>
              <div class="ui heading-bottom">
                {{ detail.companyContactAlternativeEmail }}
              </div>
            </div>

            <div appMargin marginB="15px">
              <div class="ui heading">ALTERNATIVE PHONE</div>
              <div class="ui heading-bottom">
                {{ detail.companyContactPhone1 }}
              </div>
            </div>

            <div appMargin marginB="15px">
              <div class="ui heading">WEBSITE</div>
              <div class="ui heading-bottom">{{ detail.website }}</div>
            </div>
          </ng-container>
          <ng-container
            *ngIf="
              detail && selectedRequest.changeRequestType == 'CEO-INFORMATION'
            "
          >
            <h2
              style="
                font-weight: 600;
                font-size: 16px;
                line-height: 19px;
                color: #3f4395;
              "
            >
              NEW RECORD
            </h2>
            <h2>COMPANY CEO</h2>
            <div class="ui divider"></div>

            <div appMargin marginB="15px">
              <div class="ui heading">Name of CEO</div>
              <div class="ui heading-bottom">{{ detail.ceoName }}</div>
            </div>

            <div appMargin marginB="15px">
              <div class="ui heading">Email Address</div>
              <div class="ui heading-bottom">
                {{ detail.ceoContactEmail }}
              </div>
            </div>

            <div appMargin marginB="15px">
              <div class="ui heading">Phone Number</div>
              <div class="ui heading-bottom">{{ detail.ceoContactPhone }}</div>
            </div>
          </ng-container>
          <ng-container
            *ngIf="detail && selectedRequest.changeRequestType == 'OTHER_TCC'"
          >
            <div class="ui divider"></div>
            <div appPadding paddingB="16px">
              <sui-accordion [closeOthers]="false">
                <sui-accordion-panel [isOpen]="false">
                  <div
                    title
                    [ngClass]="{
                      '#e5e7eb': open,
                      '#f9fafb': !open
                    }"
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                      height: 113px;
                      background-color: #f9fafb;
                      padding: 16px;
                      border-left: 1px solid #ecedef;
                      box-shadow: 0px 2px 4px 0px #00000040 !important;
                    "
                    (click)="open = !open"
                    fxLayout="row"
                    fxLayoutAlign="space-between center"
                  >
                    <div fxFlex="grow">
                      <div fxLayout="column">
                        <h3
                          appMargin
                          marginB="0"
                          class="card-label-1"
                          style="
                            text-transform: capitalize;
                            font-family: Roboto;
                            font-size: 16px;
                            font-weight: 500;
                            line-height: 18.75px;
                            text-align: left;
                            color: #505050;
                          "
                        >
                          {{ detail?.year | date: "y" }}
                        </h3>
                        <div fxLayout="row" appMargin marginB="12px">
                          <small
                            class="card-label-2 light"
                            appMargin
                            marginR="10px"
                            style="
                              padding-top: 10px;
                              font-family: Roboto;
                              font-size: 14px;
                              font-weight: 400;
                              line-height: 16.41px;
                              text-align: left;
                              color: #9fa0b8;
                            "
                          >
                            TAX PAID:
                            {{
                              detail?.taxPaid | currency: "NGN":"symbol-narrow"
                            }}
                          </small>
                        </div>
                      </div>
                    </div>

                    <div fxFlex="20%" fxLayoutAlign="end">
                      <i
                        [ngClass]="{ activeTab: open, right: !open, up: open }"
                        class="chevron icon one"
                        appMargin
                        marginR="5px"
                      ></i>
                    </div>
                  </div>

                  <div
                    content
                    class="sub-item"
                    style="
                      background: #f9fafb;
                      border-radius: 4px;
                      padding: 16px;
                    "
                    appMargin
                    marginB="2"
                  >
                    <div class="ui bottom attached basic segment">
                      <div appMargin marginB="15px">
                        <div class="ui heading">TOTAL PROFIT</div>
                        <div class="ui heading-bottom">
                          {{
                            detail?.totalProfit
                              | currency: "NGN":"symbol-narrow"
                          }}
                        </div>
                      </div>

                      <div appMargin marginB="15px">
                        <div class="ui heading">ACCESSIBLE PROFIT</div>
                        <div class="ui heading-bottom">
                          {{
                            detail?.assessableProfit
                              | currency: "NGN":"symbol-narrow"
                          }}
                        </div>
                      </div>

                      <div appMargin marginB="15px">
                        <div class="ui heading">TURNOVER</div>
                        <div class="ui heading-bottom">
                          {{
                            detail?.turnOver | currency: "NGN":"symbol-narrow"
                          }}
                        </div>
                      </div>

                      <div appMargin marginB="15px">
                        <div class="ui heading">TAX PAID</div>
                        <div class="ui heading-bottom">
                          {{
                            detail?.taxPaid | currency: "NGN":"symbol-narrow"
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </sui-accordion-panel>
              </sui-accordion>
            </div>
            <app-no-record-found
              *ngIf="fromValue && fromValue.length < 1"
            ></app-no-record-found>
          </ng-container>
          <ng-container
            *ngIf="
              fromValue &&
              personnelStructures.includes(selectedRequest.changeRequestType)
            "
          >
            <h2
              style="
                font-weight: 600;
                font-size: 16px;
                line-height: 19px;
                color: #3f4395;
              "
            >
              PREVIOUS
              {{ selectedRequest.changeRequestType.split("_")[0] }} RECORDS
            </h2>

            <div class="ui divider"></div>
            <div
              *ngFor="let data of fromValue; let i = index"
              appPadding
              paddingB="16px"
            >
              <sui-accordion [closeOthers]="false">
                <sui-accordion-panel [isOpen]="false">
                  <div
                    title
                    [ngClass]="{
                      '#e5e7eb': open,
                      '#f9fafb': !open
                    }"
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                      height: 113px;
                      background-color: #f9fafb;
                      padding: 16px;
                      border-left: 1px solid #ecedef;
                      box-shadow: 0px 2px 4px 0px #00000040 !important;
                    "
                    (click)="open = !open"
                    fxLayout="row"
                    fxLayoutAlign="space-between center"
                  >
                    <div fxFlex="50px" appMargin marginR="14px">
                      <img
                        *ngIf="!data.photographDocumentPath"
                        src="assets/avatar/1.jpg"
                        alt=""
                        class="ui small circular image"
                      />
                      <img
                        *ngIf="data.photographDocumentPath"
                        src="{{ baseUrl }}/public/image/?media={{
                          data.photographDocumentPath
                        }}"
                        onerror="this.onerror=null;this.src='assets/avatar/1.jpg';"
                        class="ui mini image image-large"
                      />
                    </div>

                    <div fxFlex="grow">
                      <div fxLayout="column">
                        <h3
                          appMargin
                          marginB="0"
                          class="card-label-1"
                          style="text-transform: capitalize"
                        >
                          {{ data.firstName }} {{ data.lastName }}
                        </h3>
                        <div fxLayout="row" appMargin marginB="12px">
                          <small
                            class="card-label-2 light"
                            appMargin
                            marginR="10px"
                            *ngIf="
                              selectedRequest.changeRequestType ==
                              'SHAREHOLDER_STRUCTURE'
                            "
                            style="padding-top: 10px"
                          >
                            Shareholding: {{ data.shareholding }}%
                          </small>
                          <small
                            appMargin
                            marginR="10px"
                            *ngIf="
                              selectedRequest.changeRequestType !=
                              'SHAREHOLDER_STRUCTURE'
                            "
                            style="padding-top: 10px"
                          >
                            NIN: {{ data.nationalIdNumber }}
                          </small>
                          <!-- <small
														*ngIf="
															data.actionType && data.actionType !== 'NONE'
														"
														appMargin
														marginR="10px"
													>
														{{ data.actionType }} REQUEST
													</small> -->
                        </div>
                        <div
                          *ngIf="data.actionType && data.actionType !== 'NONE'"
                          class="ui tiny circular label"
                          [ngClass]="{
                            'label-green': data.actionType == 'ADD',
                            'label-grey': data.actionType == 'NOT_CHANGED',
                            'label-red': data.actionType == 'DELETE',
                            'label-blue': data.actionType == 'UPDATE'
                          }"
                          style="
                            bottom: 1.2rem;
                            height: 20px !important;
                            padding: 0 10px !important;
                            display: inline-flex;
                            align-items: center;
                            justify-content: center;
                            font-weight: 400;
                            white-space: nowrap;
                            margin-bottom: 10px;
                            width: fit-content;
                          "
                        >
                          {{ data.actionType }}
                        </div>
                      </div>
                    </div>

                    <div fxFlex="20%" fxLayoutAlign="end">
                      <!-- <button
												class="ui right floated circular icon button light-bg"
											> -->
                      <i
                        [ngClass]="{ activeTab: open, right: !open, up: open }"
                        class="chevron icon one"
                        appMargin
                        marginR="5px"
                      ></i>
                      <!-- </button> -->
                    </div>
                  </div>

                  <div
                    content
                    class="sub-item"
                    style="
                      background: #f9fafb;
                      border-radius: 4px;
                      padding: 16px;
                    "
                    appMargin
                    marginB="2"
                  >
                    <div class="ui bottom attached basic segment">
                      <div appMargin marginB="15px">
                        <div class="ui heading">CREATED BY</div>
                        <div class="ui heading-bottom">
                          {{ selectedRequest.createdBy | createdBy }} |
                          {{ selectedRequest.dateCreated | date: "medium" }}
                        </div>
                      </div>

                      <div appMargin marginB="15px">
                        <div class="ui heading">FIRST NAME</div>
                        <div class="ui heading-bottom">
                          {{ data.firstName }}
                        </div>
                      </div>

                      <div appMargin marginB="15px">
                        <div class="ui heading">LAST NAME</div>
                        <div class="ui heading-bottom">{{ data.lastName }}</div>
                      </div>

                      <div appMargin marginB="15px">
                        <div class="ui heading">MIDDLE NAME</div>
                        <div class="ui heading-bottom">
                          {{ data.middleName }}
                        </div>
                      </div>

                      <div appMargin marginB="15px">
                        <div class="ui heading">GENDER</div>
                        <div class="ui heading-bottom">{{ data.gender }}</div>
                      </div>

                      <div appMargin marginB="15px" *ngIf="data.nationality">
                        <div class="ui heading">NATIONALITY</div>
                        <div class="ui heading-bottom">
                          {{ data?.nationality }}
                        </div>
                      </div>

                      <div appMargin marginB="15px">
                        <div class="ui heading">COUNTRY OF ORIGIN</div>
                        <div class="ui heading-bottom">
                          {{ filterCountry(data?.countryOfOriginId) }}
                        </div>
                      </div>
                      <div
                        appMargin
                        marginB="15px"
                        *ngIf="
                          selectedRequest.changeRequestType ==
                            'SHAREHOLDER_STRUCTURE' &&
                          data.companyName &&
                          data.companyRegNumber
                        "
                      >
                        <div class="ui heading">SHAREHOLDER TYPE</div>
                        <div class="ui heading-bottom">Company</div>
                      </div>
                      <div
                        appMargin
                        marginB="15px"
                        *ngIf="
                          selectedRequest.changeRequestType ==
                            'SHAREHOLDER_STRUCTURE' &&
                          !data.companyName &&
                          !data.companyRegNumber
                        "
                      >
                        <div class="ui heading">SHAREHOLDER TYPE</div>
                        <div class="ui heading-bottom">Individual</div>
                      </div>
                      <div appMargin marginB="15px" *ngIf="data.companyName">
                        <div class="ui heading">COMPANY NAME</div>
                        <div class="ui heading-bottom">
                          {{ data?.companyName }}
                        </div>
                      </div>
                      <div
                        appMargin
                        marginB="15px"
                        *ngIf="data.companyRegNumber"
                      >
                        <div class="ui heading">COMPANY REGISTRATION NAME</div>
                        <div class="ui heading-bottom">
                          {{ data?.companyRegNumber }}
                        </div>
                      </div>
                      <div
                        appMargin
                        marginB="15px"
                        *ngIf="
                          selectedRequest.changeRequestType ==
                          'SHAREHOLDER_STRUCTURE'
                        "
                      >
                        <div class="ui heading">SHAREHOLDING AMOUNT</div>
                        <div class="ui heading-bottom">
                          {{ data.shareholding }}%
                        </div>
                      </div>
                    </div>
                  </div>
                </sui-accordion-panel>
              </sui-accordion>
            </div>
            <app-no-record-found
              *ngIf="fromValue && fromValue.length < 1"
            ></app-no-record-found>
          </ng-container>
          <ng-container
            *ngIf="
              shareholder &&
              personnelStructures.includes(selectedRequest.changeRequestType)
            "
          >
            <h2
              style="
                font-weight: 600;
                font-size: 16px;
                line-height: 19px;
                color: #3f4395;
              "
            >
              {{
                selectedRequest.status === "VERIFIED"
                  ? "CURRENT"
                  : selectedRequest.status
              }}
              {{ selectedRequest.changeRequestType.split("_")[0] }} RECORDS
            </h2>
            <div class="ui divider"></div>

            <app-no-record-found
              *ngIf="shareholder && shareholder.length < 1"
            ></app-no-record-found>
            <div
              *ngFor="let data of shareholder; let i = index"
              appPadding
              paddingB="16px"
            >
              <sui-accordion [closeOthers]="false">
                <sui-accordion-panel [isOpen]="false">
                  <div
                    title
                    [ngClass]="{
                      '#e5e7eb': open,
                      '#f9fafb': !open
                    }"
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                      height: 113px;
                      background-color: #f9fafb;
                      padding: 16px;
                      border-left: 1px solid #ecedef;
                      box-shadow: 0px 2px 4px 0px #00000040 !important;
                    "
                    (click)="open = !open"
                    fxLayout="row"
                    fxLayoutAlign="space-between center"
                  >
                    <div fxFlex="20%">
                      <img
                        *ngIf="!data.photographDocumentPath"
                        src="assets/avatar/1.jpg"
                        alt=""
                        class="ui small circular image"
                      />
                      <img
                        *ngIf="data.photographDocumentPath"
                        src="{{ baseUrl }}/public/image/?media={{
                          data.photographDocumentPath
                        }}"
                        onerror="this.onerror=null;this.src='assets/avatar/1.jpg';"
                        class="ui mini image image-large"
                      />
                    </div>

                    <div fxFlex="grow">
                      <div fxLayout="column">
                        <h3
                          class="card-label-1"
                          appMargin
                          marginB="0"
                          style="text-transform: capitalize"
                        >
                          {{ data.firstName }} {{ data.lastName }}
                        </h3>
                        <div fxLayout="row" appMargin marginB="12px">
                          <small
                            class="card-label-2 light"
                            appMargin
                            marginR="10px"
                            *ngIf="
                              selectedRequest.changeRequestType ==
                              'SHAREHOLDER_STRUCTURE'
                            "
                            style="padding-top: 10px"
                          >
                            Shareholding: {{ data.shareholding }}%
                          </small>
                          <small
                            appMargin
                            marginR="10px"
                            *ngIf="
                              selectedRequest.changeRequestType !=
                              'SHAREHOLDER_STRUCTURE'
                            "
                            style="padding-top: 10px"
                          >
                            NIN: {{ data.nationalIdNumber }}
                          </small>
                          <!-- <small
														*ngIf="
															data.actionType && data.actionType !== 'NONE'
														"
														appMargin
														marginR="10px"
													>
														{{ data.actionType }} REQUEST
													</small> -->
                        </div>
                        <div
                          *ngIf="data.actionType && data.actionType !== 'NONE'"
                          class="ui tiny circular label"
                          [ngClass]="{
                            'label-green': data.actionType == 'ADD',
                            'label-grey': data.actionType == 'NOT_CHANGED',
                            'label-red': data.actionType == 'DELETE',
                            'label-blue': data.actionType == 'UPDATE'
                          }"
                          style="
                            bottom: 1.2rem;
                            height: 20px !important;
                            padding: 0 10px !important;
                            display: inline-flex;
                            align-items: center;
                            justify-content: center;
                            font-weight: 400;
                            white-space: nowrap;
                            margin-bottom: 10px;
                            width: fit-content;
                          "
                        >
                          {{ data.actionType }}
                        </div>
                      </div>
                    </div>

                    <div fxFlex="20%" fxLayoutAlign="end">
                      <!-- <button
                    (click)="toggleHistory(i)"
                    class="ui right floated circular icon button light-bg"
                  >
                    <i class="chevron down icon" appMargin marginR="5px"></i>
                  </button> -->
                      <!-- <button
												class="ui right floated circular icon button light-bg"
											> -->
                      <i
                        [ngClass]="{ activeTab: open, right: !open, up: open }"
                        class="chevron icon one"
                        appMargin
                        marginR="5px"
                      ></i>
                      <!-- </button> -->
                    </div>
                  </div>

                  <div
                    content
                    class="sub-item"
                    style="
                      background: #f9fafb;
                      border-radius: 4px;
                      padding: 16px;
                    "
                    appMargin
                    marginB="2"
                  >
                    <div class="ui bottom attached basic segment">
                      <div appMargin marginB="15px">
                        <div class="ui heading">CREATED BY</div>
                        <div class="ui heading-bottom">
                          {{ selectedRequest.createdBy | createdBy }} |
                          {{ selectedRequest.dateCreated | date: "medium" }}
                        </div>
                      </div>

                      <div appMargin marginB="15px">
                        <div class="ui heading">FIRST NAME</div>
                        <div class="ui heading-bottom">
                          {{ data.firstName }}
                        </div>
                      </div>

                      <div appMargin marginB="15px">
                        <div class="ui heading">LAST NAME</div>
                        <div class="ui heading-bottom">{{ data.lastName }}</div>
                      </div>

                      <div appMargin marginB="15px">
                        <div class="ui heading">MIDDLE NAME</div>
                        <div class="ui heading-bottom">
                          {{ data.middleName }}
                        </div>
                      </div>

                      <div appMargin marginB="15px">
                        <div class="ui heading">GENDER</div>
                        <div class="ui heading-bottom">{{ data.gender }}</div>
                      </div>

                      <div appMargin marginB="15px" *ngIf="data.nationality">
                        <div class="ui heading">NATIONALITY</div>
                        <div class="ui heading-bottom">
                          {{ data.nationality }}
                        </div>
                      </div>

                      <div appMargin marginB="15px">
                        <div class="ui heading">COUNTRY OF ORIGIN</div>
                        <div class="ui heading-bottom">
                          {{ filterCountry(data.countryOfOriginId) }}
                        </div>
                      </div>
                      <div
                        appMargin
                        marginB="15px"
                        *ngIf="
                          selectedRequest.changeRequestType ==
                            'SHAREHOLDER_STRUCTURE' &&
                          data.companyName &&
                          data.companyRegNumber
                        "
                      >
                        <div class="ui heading">SHAREHOLDER TYPE</div>
                        <div class="ui heading-bottom">Company</div>
                      </div>
                      <div
                        appMargin
                        marginB="15px"
                        *ngIf="
                          selectedRequest.changeRequestType ==
                            'SHAREHOLDER_STRUCTURE' &&
                          !data.companyName &&
                          !data.companyRegNumber
                        "
                      >
                        <div class="ui heading">SHAREHOLDER TYPE</div>
                        <div class="ui heading-bottom">Individual</div>
                      </div>
                      <div appMargin marginB="15px" *ngIf="data.companyName">
                        <div class="ui heading">COMPANY NAME</div>
                        <div class="ui heading-bottom">
                          {{ data?.companyName }}
                        </div>
                      </div>
                      <div
                        appMargin
                        marginB="15px"
                        *ngIf="data.companyRegNumber"
                      >
                        <div class="ui heading">COMPANY REGISTRATION NAME</div>
                        <div class="ui heading-bottom">
                          {{ data?.companyRegNumber }}
                        </div>
                      </div>
                      <div
                        appMargin
                        marginB="15px"
                        *ngIf="
                          selectedRequest.changeRequestType ==
                          'SHAREHOLDER_STRUCTURE'
                        "
                      >
                        <div class="ui heading">SHAREHOLDING AMOUNT</div>
                        <div class="ui heading-bottom">
                          {{ data.shareholding }}%
                        </div>
                      </div>
                    </div>
                  </div>
                </sui-accordion-panel>
              </sui-accordion>
            </div>
          </ng-container>

          <ng-container class="document" *ngIf="documents?.length > 0">
            <h2
              style="
                font-weight: 600;
                font-size: 16px;
                line-height: 19px;
                color: #3f4395;
              "
            >
              {{
                selectedRequest.changeRequestType === "OFFICIAL_DOCUMENT"
                  ? "Uploaded Official Documents"
                  : "Uploaded Supporting Documents"
              }}
            </h2>
            <div class="ui divider"></div>

            <div>
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  flex-direction: column;
                  margin-bottom: 16px;
                "
                *ngFor="let docType of groupedDocuments; let i = index"
              >
                <sui-accordion [closeOthers]="false">
                  <sui-accordion-panel [isOpen]="false">
                    <div
                      title
                      [ngClass]="{
                        '#e5e7eb': open,
                        '#f9fafb': !open
                      }"
                      style="
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        height: 113px;
                        background-color: #f9fafb;
                        padding: 16px;
                        border-left: 1px solid #ecedef;
                        box-shadow: 0px 2px 4px 0px #00000040 !important;
                      "
                      (click)="open = !open"
                      fxLayout="row"
                      fxLayoutAlign="space-between center"
                    >
                      <div fxFlex="grow">
                        <h2
                          *ngIf="
                            selectedRequest.changeRequestType !==
                            'OFFICIAL_DOCUMENT'
                          "
                          class="ui head"
                          fxFlex="auto"
                          style="
                            font-weight: 400;
                            font-size: 16px;
                            line-height: 19px;
                            color: #3f4395;
                          "
                        >
                          {{ docType.key }}
                        </h2>
                        <h2
                          *ngIf="
                            selectedRequest.changeRequestType ===
                            'OFFICIAL_DOCUMENT'
                          "
                          class="ui head"
                          fxFlex="auto"
                          style="
                            font-weight: 400;
                            font-size: 16px;
                            line-height: 19px;
                            color: #3f4395;
                          "
                        >
                          {{ detail?.documentTypeName }}
                        </h2>
                      </div>
                      <div fxFlex="20%" fxLayoutAlign="end">
                        <button
                          class="ui right floated circular icon button light-bg"
                        >
                          <i
                            [ngClass]="{
                              activeTab: open,
                              right: !open,
                              up: open
                            }"
                            class="chevron icon"
                            appMargin
                            marginR="5px"
                          ></i>
                        </button>
                      </div>
                    </div>

                    <div
                      content
                      class="sub-item"
                      style="
                        background: #f9fafb;
                        border-radius: 4px;
                        padding: 16px;
                      "
                      appMargin
                      marginB="2"
                    >
                      <div class="ui bottom attached basic segment">
                        <div
                          class="doc-wrap"
                          style="
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            margin-bottom: 15px;
                          "
                          *ngFor="let doc of docType.value; let i = index"
                        >
                          <div
                            style="
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                            "
                            *ngIf="!doc.checkbox"
                          >
                            <div style="display: flex; align-items: center">
                              <img
                                src="../../../../../assets/icons/document-text.svg"
                                alt="data"
                                height="20px"
                                width="20px"
                              />
                              <p
                                style="
                                  margin-left: 20px;
                                  font-style: normal;
                                  font-weight: 400;
                                  font-size: 14px;
                                  line-height: 16px;
                                  color: #6d7175;
                                "
                              >
                                {{
                                  doc.documentPath
                                    .split("______")[1]
                                    .replaceAll("_", " ")
                                }}
                              </p>
                            </div>
                            <div>
                              <button
                                class="view-btn"
                                (click)="viewDocument(doc)"
                                suiPopup
                                popupPlacement="top"
                                popupText="View"
                              >
                                <i class="eye icon"></i>
                              </button>
                            </div>
                          </div>
                          <div
                            *ngIf="doc.checkbox"
                            style="
                              width: 100%;
                              display: flex;
                              align-items: center;
                            "
                          >
                            <div>
                              <div class="linked_document">
                                <div class="contents">
                                  <div class="content_name">
                                    <div
                                      style="
                                        display: flex;
                                        justify-content: space-between;
                                        align-items: center;
                                        width: 100%;
                                      "
                                    >
                                      <div class="name">
                                        <img
                                          src="assets/icons/document-text.svg"
                                          alt=""
                                          style="
                                            width: 20px !important;
                                            height: 20px !important;
                                          "
                                        />
                                        <h5>
                                          {{
                                            doc.documentPath
                                              .split("______")[1]
                                              .replaceAll("_", " ")
                                          }}
                                        </h5>
                                      </div>
                                      <div class="action_button">
                                        <img
                                          src="assets/icons/Frame 5492.svg"
                                          suiPopup
                                          [popupInverted]="true"
                                          popupPlacement="bottom"
                                          popupText="View"
                                          (click)="viewDocument(doc)"
                                          alt=""
                                          style="
                                            width: 20px !important;
                                            height: 20px !important;
                                          "
                                        />
                                      </div>
                                    </div>

                                    <p class="paragraph">ADDED BY:</p>
                                    <div class="information">
                                      <div class="info">
                                        <div class="flex">
                                          <h4 style="width: 45%">
                                            <img
                                              src="assets/icons/User.svg"
                                              alt=""
                                              style="
                                                width: 16px !important;
                                                height: 16px !important;
                                              "
                                            />{{ doc.createdBy | createdBy }}
                                          </h4>
                                          <h4>
                                            <img
                                              src="assets/icons/Clock 2.svg"
                                              alt=""
                                              style="
                                                width: 16px !important;
                                                height: 16px !important;
                                              "
                                            />
                                            {{
                                              doc.dateCreated
                                                | date: "d MMM, y h:mm a"
                                            }}
                                          </h4>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </sui-accordion-panel>
                </sui-accordion>
              </div>
            </div>
          </ng-container>
          <ng-container
            class="approvals"
            *ngIf="selectedRequest.status === 'VERIFIED'"
          >
            <h2
              style="
                font-weight: 600;
                font-size: 16px;
                line-height: 19px;
                color: #3f4395;
              "
            >
              Approvals
            </h2>
            <div
              style="
                display: flex;
                align-items: flex-start;
                justify-content: center;
                flex-direction: column;
                height: 85px;
                border-top: 1px solid #dfdfdf;
              "
            >
              <div style="display: flex; align-items: center">
                <div>
                  <span
                    class="ui rounded label"
                    style="border-radius: 10px"
                    [ngClass]="{
                      red: selectedRequest.status == 'UNVERIFIED',
                      green: selectedRequest.status == 'VERIFIED',
                      yellow: selectedRequest.status == 'PENDING'
                    }"
                    >{{ selectedRequest?.status }}</span
                  >
                </div>
                <div style="margin-left: 15px">
                  <p
                    style="
                      font-style: normal;
                      font-weight: 400;
                      font-size: 16px;
                      line-height: 19px;
                      color: #505050;
                    "
                  >
                    {{ selectedRequest?.approvedBy | createdBy }}
                  </p>
                </div>
              </div>
              <div class="flex" style="margin-top: 14px">
                <div class="flex">
                  <img
                    src="../../../../../assets/icons/people.svg"
                    style="margin-right: 8px"
                    alt="data"
                  />
                  <p
                    style="
                      font-weight: 400;
                      font-size: 14px;
                      line-height: 16px;
                      color: #828282;
                    "
                  >
                    {{ selectedRequest?.approvedBy | createdByOrg }}
                  </p>
                </div>
                <div class="flex" style="margin-left: 15px">
                  <img
                    src="../../../../../assets/icons/clock.svg"
                    style="margin-right: 8px"
                    alt="data"
                  />
                  <p
                    style="
                      font-weight: 400;
                      font-size: 14px;
                      line-height: 16px;
                      color: #828282;
                    "
                  >
                    {{
                      selectedRequest?.dateApproved | date: "d, MMMM y, h:mm a"
                    }}
                  </p>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="!isPending && allHistory">
          <h4 *ngIf="item?.changeRequestType === 'OTHER_TCC'">
            FIRS Tax Clearance NO: {{ modal.context.data?.tccNumber }}
          </h4>
          <div class="ui label warning-label">
            <span>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10 7.5V10.625M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10ZM10 13.125H10.0063V13.1313H10V13.125Z"
                  stroke="#2C6ECB"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>

            <div class="text">Select a date to view more details.</div>
          </div>
          <form class="ui form">
            <div class="grouped fields">
              <div
                class="field"
                *ngFor="let item of allHistory"
                appMargin
                marginB="20px"
              >
                <div class="ui vertical segment card-one">
                  <div
                    fxLayout="row"
                    fxLayoutAlign="space-between center"
                    (click)="submit()"
                  >
                    <!-- <div fxFlex="15%"> -->
                    <sui-radio-button
                      style="
                        width: 100%;
                        position: relative;
                        top: 20px !important;
                      "
                      name="timer"
                      [value]="item.changeRequestId"
                      [(ngModel)]="isChecked"
                    >
                      <!-- <div fxFlex="10%"></div> -->
                      <div fxFlex="grow">
                        <div
                          fxLayout="column"
                          style="position: relative; bottom: 1.2rem"
                        >
                          <h3 class="card-label-1">
                            {{ item.dateCreated | date: "medium" }}
                          </h3>
                          <div fxLayout="row">
                            <small
                              appMargin
                              marginR="10px"
                              class="card-label-2"
                            >
                              <i class="building outline icon"></i>
                              {{ returnJson(item.createdBy)?.organizationName }}
                            </small>
                            <small class="card-label-2">
                              <i class="clock outline icon"></i>
                              {{ item.dateCreated | date: "medium" }}
                            </small>
                          </div>
                        </div>
                      </div>

                      <div
                        fxFlex="15%"
                        fxLayoutAlign="end"
                        *ngIf="item.changeRequestType !== 'CEO-INFORMATION'"
                      >
                        <div
                          class="ui tiny circular label"
                          [ngClass]="{
                            'label-green': item.status == 'VERIFIED',
                            'label-grey': item.status == 'NOT_AVAILABLE',
                            'label-red':
                              item.status == 'REJECTED' ||
                              item.status == 'UNVERIFIED',
                            'label-orange': item.status == 'PENDING'
                          }"
                          style="
                            position: relative;
                            bottom: 1.2rem;
                            height: 20px !important;
                            padding: 0 10px !important;
                            display: inline-flex;
                            align-items: center;
                            justify-content: center;
                            font-weight: 400;
                            white-space: nowrap;
                          "
                        >
                          {{
                            item.status == "PENDING"
                              ? "PENDING VERIFICATION"
                              : item.status == "REJECTED"
                              ? "FAILED VERIFICATION"
                              : item.status == "UNVERIFIED"
                              ? "UNVERIFIED VERIFICATION"
                              : item.status == "VERIFIED"
                              ? "VERIFIED"
                              : item.status
                          }}
                        </div>
                      </div>
                    </sui-radio-button>
                    <!-- </div> -->
                  </div>
                </div>
              </div>
              <app-no-record-found
                *ngIf="allHistory && allHistory.length < 1"
              ></app-no-record-found>
            </div>
          </form>
          <div class="ui vertical basic segment">
            <div class="ui two column grid">
              <div class="column middle aligned">
                <div class="ui icon button" (click)="getPage(1)">
                  <i class="refresh icon"></i>
                </div>
                <a class="ui basic label">{{ totalItems }} Record(s)</a>
              </div>
              <div
                class="column right aligned pagination menu"
                style="margin-left: auto"
              >
                <sui-pagination
                  class="small"
                  [collectionSize]="totalItems"
                  [pageSize]="rows"
                  [maxSize]="maxSize"
                  [hasEllipses]="false"
                  [page]="currentPage"
                  (pageChange)="nextPage($event)"
                >
                </sui-pagination>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div
    class="actions"
    style="
      background: transparent;
      border: none;
      position: relative;
      margin-top: 20px;
    "
  >
    <button
      class="ui basic primary button"
      *ngIf="!isPending"
      (click)="modal.deny(undefined)"
    >
      Close
    </button>
    <button
      class="ui basic primary button"
      *ngIf="isPending"
      (click)="modal.approve()"
      autofocus
    >
      Cancel
    </button>
    <button
      class="ui primary button"
      *ngIf="isPending"
      [ngClass]="{ yellow: pending }"
      [disabled]="pending || !isChecked"
      (click)="goBackToList()"
      autofocus
    >
      Back
    </button>
  </div>
</div>
